import { render, staticRenderFns } from "./dept-ureg.vue?vue&type=template&id=a06b28ce&scoped=true"
import script from "./dept-ureg.vue?vue&type=script&lang=js"
export * from "./dept-ureg.vue?vue&type=script&lang=js"
import style0 from "./dept-ureg.vue?vue&type=style&index=0&id=a06b28ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b28ce",
  null
  
)

export default component.exports